import { render, staticRenderFns } from "./SpecialCoun2.vue?vue&type=template&id=a4cc2c9c&scoped=true"
import script from "./SpecialCoun2.vue?vue&type=script&lang=js"
export * from "./SpecialCoun2.vue?vue&type=script&lang=js"
import style0 from "./SpecialCoun2.vue?vue&type=style&index=0&id=a4cc2c9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cc2c9c",
  null
  
)

export default component.exports